import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./BikeRentalPage.css"; // reuse same CSS

// 🔹 Bicycle Images (replace with your assets)
import MTB from "../../assets/MTB.png";
import RoadBike from "../../assets/RoadBike.png";
import ElectricBike from "../../assets/ElectricBike.png";

// 🔹 BICYCLE DATA
const bicycleData = {
  Mountain: [
    {
      name: "Hero MTB",
      fuels: ["Manual"],
      image: MTB,
    },
  ],
  Road: [
    {
      name: "Firefox Road Bike",
      fuels: ["Manual"],
      image: RoadBike,
    },
  ],
  Electric: [
    {
      name: "E-Bike Pro",
      fuels: ["Electric"],
      image: ElectricBike,
    },
  ],
};

// 🔹 GENERATE ALL CARDS
const generateAllCards = () => {
  let cards = [];
  let id = 0;

  Object.keys(bicycleData).forEach((type) => {
    bicycleData[type].forEach((model) => {
      model.fuels.forEach((fuel) => {
        cards.push({
          id: id++,
          name: model.name,
          type,
          fuel,
          image: model.image,
          price: type === "Electric" ? 400 : 200,
          distance: ["0-20km", "21-50km", "51-100km"][
            Math.floor(Math.random() * 3)
          ],
          rating: (4 + Math.random()).toFixed(1),
        });
      });
    });
  });

  return cards;
};

const BicycleRentalPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [tripData, setTripData] = useState(null);

  const [distance, setDistance] = useState("");
  const [priceSort, setPriceSort] = useState("");

  const [cycleType, setCycleType] = useState("");
  const [cycleModel, setCycleModel] = useState("");
  const [fuelType, setFuelType] = useState("");

  // 🔥 FIXED tripData logic
  useEffect(() => {
    let data = location.state;

    if (!data) {
      const saved = localStorage.getItem("tripData");
      data = saved ? JSON.parse(saved) : null;
    }

    if (!data) {
      alert("Please fill booking details first");
      navigate("/");
    } else {
      setTripData(data);
    }
  }, [location.state, navigate]);

  if (!tripData) return null;

  const models = cycleType ? bicycleData[cycleType] : [];
  const selectedModel = models.find((m) => m.name === cycleModel);
  const fuels = selectedModel?.fuels || [];

  let cards = [];

  if (cycleType && cycleModel && fuelType) {
    cards = [
      {
        id: 1,
        name: cycleModel,
        type: cycleType,
        fuel: fuelType,
        image: selectedModel?.image,
        price: cycleType === "Electric" ? 400 : 200,
        distance: distance || "0-20km",
        rating: 4.5,
      },
    ];
  } else {
    cards = generateAllCards();
  }

  let filteredCards = cards.filter((b) => !distance || b.distance === distance);

  if (priceSort === "low-high") {
    filteredCards.sort((a, b) => a.price - b.price);
  } else if (priceSort === "high-low") {
    filteredCards.sort((a, b) => b.price - a.price);
  }

  // 🔹 SELECT BICYCLE
  const handleSelectCycle = (cycle) => {
    const bookingData = {
      vehicle: "bicycle",
      bicycleData: cycle,

      extraCharges: 50,
      fuelCharges: 0,

      pickup: tripData?.pickup,
      drop: tripData?.drop,
      bookingDate: tripData?.date,
      bookingTime: tripData?.time,
    };

    localStorage.setItem("bookingData", JSON.stringify(bookingData));

    navigate("/bicycle-rental-detail-page", {
      state: bookingData,
    });
  };

  return (
    <div className="container">
      <h2>Book Your Bicycle 🚴‍♂️</h2>

      {/* 🔹 FILTERS */}
      <div className="dropdowns">
        <select onChange={(e) => setDistance(e.target.value)}>
          <option value="">Distance</option>
          <option>0-20km</option>
          <option>21-50km</option>
          <option>51-100km</option>
        </select>

        <select onChange={(e) => setPriceSort(e.target.value)}>
          <option value="">Price</option>
          <option value="low-high">Low → High</option>
          <option value="high-low">High → Low</option>
        </select>

        <select
          value={cycleType}
          onChange={(e) => {
            setCycleType(e.target.value);
            setCycleModel("");
            setFuelType("");
          }}
        >
          <option value="">Cycle Type</option>
          {Object.keys(bicycleData).map((type) => (
            <option key={type} value={type}>
              {type}
            </option>
          ))}
        </select>

        <select
          value={cycleModel}
          onChange={(e) => {
            setCycleModel(e.target.value);
            setFuelType("");
          }}
          disabled={!cycleType}
        >
          <option value="">Cycle Model</option>
          {models.map((m) => (
            <option key={m.name} value={m.name}>
              {m.name}
            </option>
          ))}
        </select>

        <select
          value={fuelType}
          onChange={(e) => setFuelType(e.target.value)}
          disabled={!cycleModel}
        >
          <option value="">Type</option>
          {fuels.map((f) => (
            <option key={f} value={f}>
              {f}
            </option>
          ))}
        </select>
      </div>

      {/* 🔹 CARDS */}
      <div className="card-container">
        {filteredCards.map((cycle) => (
          <div className="car-card" key={cycle.id}>
            <div className="card-image">
              <img src={cycle.image} alt="cycle" />
              <span className="fuel-tag">{cycle.fuel}</span>
            </div>

            <div className="card-content">
              <h2 className="car-title">{cycle.name.toUpperCase()}</h2>
              <p className="car-sub">{cycle.type} • 1 Seater</p>

              <div className="price-row">
                <div>
                  <span className="old-price">₹500</span>
                  <h3 className="new-price">
                    ₹{cycle.price}
                    <span>/day</span>
                  </h3>
                </div>

                <button
                  className="view-btn"
                  onClick={() => handleSelectCycle(cycle)}
                >
                  VIEW MORE
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BicycleRentalPage;
